module.exports = __webpack_public_path__ + "static/img/bannerTxt3.c2b19be7.png";